import { render, staticRenderFns } from "./SyncTicketPro.vue?vue&type=template&id=197aac7a&scoped=true"
import script from "./SyncTicketPro.vue?vue&type=script&lang=js"
export * from "./SyncTicketPro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197aac7a",
  null
  
)

export default component.exports